module.exports = __webpack_public_path__ + "fonts/SourceSansPro-Light.24185053.ttf";